.in-product-trials-header {
  display: inline;
}

#in-product-trials-header-normal-heading4 {
  font-weight: 400;

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
}

#in-product-trials-header-medium-heading4 {
  font-weight: 500;
}

#in-product-trials-header-normal-heading4,
#in-product-trials-header-medium-heading4 {
  color: var(--body-text-arrows-400);
  font-size: var(--body-size-large);
}

#in-product-trials-header-medium-body {
  font-weight: 500;
  font-size: var(--header-font-size);
  color: var(--main-titles-inputs-600);
}

span + span:before {
  content: '/';
  font-weight: 400;
  padding: 0 8px;
  font-size: var(--body-size-large);
}
